import { gql } from '@apollo/client';
import { SaleItemConnectorRefFragment } from '../fragments/SaleItemConnectorRefFragment';
/**
 * @const SaleItemConnectorRefsQuery
 * @since 1.0.0
 */
export const SaleItemConnectorRefsQuery = gql `
  query SaleItemConnectorRefsQuery($input: SaleItemConnectorRefsInput!) {
    saleItemConnectorRefs(input: $input) {
      ...SaleItemConnectorRefFragment
    }
  }

  ${SaleItemConnectorRefFragment}
`;
